angular.module('lf.common')

.directive('validPostalCode', function () {
  return {
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
        var valid = model.$isEmpty(val) ||
          (!lf.data.formData.validation.postalCode.regex || lf.data.formData.validation.postalCode.regex.test(val));
        model.$setValidity('postalCode', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
